/**
 * Утилиты для работы с регионами
 * Pure functions - не имеют побочных эффектов
 */

/**
 * Форматирует название региона для отображения
 * @param {string} name - Название региона
 * @returns {string} - Отформатированное название
 */
export function formatRegionName(name) {
  if (!name) return name
  
  // Обрабатываем разные варианты названия (без учета регистра и пробелов)
  const normalizedName = name.trim().toLowerCase().replace(/\s+/g, ' ')
  
  if (normalizedName === 'московская область' || normalizedName.includes('московская область')) {
    return 'Москва и МО'
  }
  
  // Дополнительная проверка на возможные варианты
  if (normalizedName.includes('московск') && normalizedName.includes('област')) {
    return 'Москва и МО'
  }
  
  return name
}
